import { useLayoutEffect } from 'react';

// The CSS class predates internal full-document workspaces. Keep its value
// stable so public routes retain their established layout contract.
const DOCUMENT_SCROLL_CLASS = 'public-page-document-scroll';
let documentScrollUsers = 0;

/**
 * The portal shell intentionally locks document scrolling. Full-document
 * routes opt back in while mounted and restore the shell behavior when
 * navigation leaves the last owner. Layout effects keep the switch in the
 * same pre-paint commit, including StrictMode cleanup/setup and route changes.
 */
export function useDocumentScroll(): void {
  useLayoutEffect(() => {
    if (documentScrollUsers === 0) {
      document.documentElement.classList.add(DOCUMENT_SCROLL_CLASS);
    }
    documentScrollUsers += 1;

    return () => {
      documentScrollUsers = Math.max(0, documentScrollUsers - 1);
      if (documentScrollUsers === 0) {
        document.documentElement.classList.remove(DOCUMENT_SCROLL_CLASS);
      }
    };
  }, []);
}

export function usePublicPageDocumentScroll(): void {
  useDocumentScroll();
}
